import React from 'react';
import { Invoices } from '../../../../api/api-invoices';
import Contracts from '../../../../api/api-contracts';
import * as types from '../constants/action-types';
import { get } from 'lodash';
import { INVOICES_YEARS_FETCH_FAILURE } from '../constants/action-types';

export function fetchInvoicesByYearRequest (isFetching) {
  return {
    type: types.INVOICES_BY_YEAR_REQUEST,
    isFetching
  };
}

export function fetchInvoicesByYearSuccess (data) {
  return {
    type: types.INVOICES_BY_YEAR_SUCCESS,
    data
  };
}

export function fetchInvoicesByYearFailure (fetchError) {
  return {
    type: types.INVOICES_BY_YEAR_FAILURE,
    fetchError
  };
}

export function fetchInvoicesRequest (isFetching) {
  return {
    type: types.INVOICES_FETCH_REQUEST,
    isFetching
  };
}

export function fetchInvoicesSuccess (data) {
  return {
    type: types.INVOICES_FETCH_SUCCESS,
    data
  };
}

export function fetchInvoicesFailure (fetchError) {
  return {
    type: types.INVOICES_FETCH_FAILURE,
    fetchError
  };
}

export function fetchInvoicesYearsRequest (isFetching) {
  return {
    type: types.INVOICES_YEARS_FETCH_REQUEST,
    isFetching
  };
}

export function fetchInvoicesYearsSuccess (data) {
  return {
    type: types.INVOICES_YEARS_FETCH_SUCCESS,
    data
  };
}

export function fetchInvoicesYearsFailure (fetchError) {
  return {
    type: types.INVOICES_YEARS_FETCH_FAILURE,
    fetchError
  };
}

export function fetchInvoiceEntriesRequest (isFetching) {
  return {
    type: types.INVOICE_ENTRIES_FETCH_REQUEST,
    isFetching
  };
}

export function fetchInvoiceEntriesSuccess (data) {
  return {
    type: types.INVOICE_ENTRIES_FETCH_SUCCESS,
    data
  };
}

export function fetchInvoiceEntriesFailure (fetchError) {
  return {
    type: types.INVOICE_ENTRIES_FETCH_FAILURE,
    fetchError
  };
}

export function fetchInvoiceEntriesByTypeRequest (isFetching) {
  return {
    type: types.INVOICE_ENTRIES_BY_TYPE_REQUEST,
    isFetching
  }
}

export function fetchInvoiceEntriesByTypeSuccess (data) {
  return {
    type: types.INVOICE_ENTRIES_BY_TYPE_SUCCESS,
    data
  }
}

export function fetchInvoiceEntriesByTypeFailure (fetchError) {
  return {
    type: types.INVOICE_ENTRIES_BY_TYPE_FAILURE,
    fetchError
  }
}

export function fetchSpaceRentalsInfoRequest (isFetching) {
  return {
    type: types.INVOICE_FETCH_SPACE_RENTALS_REQUEST,
    isFetching
  };
}

export function fetchSpaceRentalsInfoSuccess (data) {
  return {
    type: types.INVOICE_FETCH_SPACE_RENTALS_SUCCESS,
    data
  };
}

export function fetchSpaceRentalsInfoFailure (error) {
  return {
    type: types.INVOICE_FETCH_SPACE_RENTALS_FAILURE,
    error
  };
}

// Returns invoices in a specific year
export function fetchInvoicesByYear (ssoId, accessToken, year, limit, skip) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchInvoicesByYearRequest(true));

      Invoices.fetchInvoicesByYear(ssoId, accessToken, year, limit, skip, response => {
        if (200 === response.statusCode) {
          dispatch(fetchInvoicesByYearSuccess(response));

          return resolve(response);
        }
        const defaultErrMsg = 'Error fetching invoices by year';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchInvoicesByYearFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}

// Returns all invoices categorized by year
export function fetchInvoices (ssoId, accessToken) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchInvoicesRequest(true));

      Invoices.fetchInvoices(ssoId, accessToken, response => {
        if (200 === response.statusCode) {
          dispatch(fetchInvoicesSuccess(response));

          return resolve(response);
        }
        const defaultErrMsg = 'Error fetching invoices by year';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchInvoicesFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}

export function fetchInvoicesYears (ssoId, accessToken) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchInvoicesYearsRequest(true));

      Invoices.fetchInvoicesYears(ssoId, accessToken, response => {
        if (200 === response.statusCode) {
          dispatch(fetchInvoicesYearsSuccess(response));

          return resolve(response);
        }
        const errorMessage = get(response, 'error', '');
        dispatch(fetchInvoicesYearsFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}

export function fetchInvoiceEntries (accessToken, invoiceId) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchInvoiceEntriesRequest(true));

      Invoices.fetchInvoiceEntries(accessToken, invoiceId, response => {
        if (200 === response.statusCode) {
          dispatch(fetchInvoiceEntriesSuccess(response));

          return resolve(response);
        }
        const defaultErrMsg = 'Error fetching invoice entries';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchInvoiceEntriesFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}

export function fetchInvoiceEntriesByType (accessToken, invoiceId, txnType) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchInvoiceEntriesByTypeRequest(true));

      Invoices.fetchInvoiceEntriesByType(accessToken, invoiceId, txnType, response => {
        if (200 === response.statusCode) {
          dispatch(fetchInvoiceEntriesByTypeSuccess(response));

          return resolve(response);
        }
        const defaultErrMsg = 'Error fetching invoice entries';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchInvoiceEntriesByTypeFailure(errorMessage));

        return reject(errorMessage);
      });
    });
  };
}

export function fetchSpaceRentalsInfo (accessToken, query) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      dispatch(fetchSpaceRentalsInfoRequest(true));
      Contracts.fetchSpaceRentalsInfo(accessToken, query, response => {
        if (200 === response.statusCode) {
          const { statusCode, ...data } = response;
          dispatch(fetchSpaceRentalsInfoSuccess(data));
          return resolve(data);
        }
        const defaultErrMsg = 'Error fetching space rentals info';
        const errorMessage = get(response, 'error', defaultErrMsg);
        dispatch(fetchSpaceRentalsInfoFailure(errorMessage));
        return reject(errorMessage);
      });
    });
  };
}
